import { getRoleKey } from '@/utils/platformHelpers';

const DELETE_ANY_BACKEND_ROLES = new Set([
  'BOSS',
  'SUPERADMIN',
  'ADMIN',
  'PLATFORM_ADMIN',
  'ROOT',
  'DESIGNER_LEADER',
]);

const OWN_ONLY_DELETE_LOGIN_ROLES = new Set(['designer', 'customer_service']);

export function normalizeBackendRole(role) {
  return String(role || '').trim().toUpperCase().replace(/^ROLE_/, '');
}

export function hasDeleteAnyMaterialAccess({ backendRoles = [], loginRoleKey = '' } = {}) {
  const roles = (Array.isArray(backendRoles) ? backendRoles : [backendRoles])
    .map(normalizeBackendRole)
    .filter(Boolean);
  if (roles.some(role => DELETE_ANY_BACKEND_ROLES.has(role))) return true;
  return getRoleKey(loginRoleKey) === 'platform_admin';
}

export function materialOwnerUserId(material) {
  if (!material) return '';
  const raw = material.uploadUserId ?? material.createUserId ?? material.ownerId ?? material.uploaderId;
  if (raw == null || raw === '') return '';
  const digits = String(raw).replace(/\D/g, '');
  return digits || String(raw);
}

export function isMaterialOwnedByUser(material, currentUserId) {
  const owner = materialOwnerUserId(material);
  const current = String(currentUserId ?? '').replace(/\D/g, '') || String(currentUserId ?? '');
  if (!owner || !current) return false;
  return owner === current;
}

export function canDeleteMaterial(material, context = {}) {
  if (!material) return false;
  const {
    backendRoles = [],
    loginRoleKey = '',
    userId = null,
    sessionUserId = null,
  } = context;
  if (hasDeleteAnyMaterialAccess({ backendRoles, loginRoleKey })) return true;

  const loginKey = getRoleKey(loginRoleKey);
  if (loginKey === 'store_manager') return true;

  if (OWN_ONLY_DELETE_LOGIN_ROLES.has(loginKey)) {
    return isMaterialOwnedByUser(material, sessionUserId ?? userId);
  }

  return false;
}
